export default "__VITE_ASSET__WadqzyKd__"